export default __webpack_public_path__ + "static/media/pot1.29f43168.svg";